import Api from 'lib/api';

import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';
import { LOGIN_SUCCESS } from 'components/app/login/actions';

const api = Api.getInstance();

const ns = 'app/account/';

export const UPDATE_START = ns + 'UPDATE_START';
export const UPDATE_SUCCESS = ns + 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = ns + 'UPDATE_FAILURE';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';

export function update(data) {
  return async dispatch => {
    dispatch({
      type: UPDATE_START
    });

    try {
      const response = await api.post('users/save-account', data);
      const { user, success } = response.data;

      if (success) {
        localStorage.setItem('user', JSON.stringify(user));

        toast.success('Account updated!');

        dispatch({
          type: UPDATE_SUCCESS
        });

        dispatch({
          type: LOGIN_SUCCESS,
          payload: user
        });

        return;
      }

      dispatch({
        type: UPDATE_FAILURE,
        payload: response.data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      toast.error(response.message);

      dispatch({
        type: UPDATE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};

        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function deleteAccount(data, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      const response = await api.post('users/delete-account');
      const { success } = response.data;

      if (success) {
        localStorage.setItem('user', null);

        toast.success('Account deleted!');

        dispatch({
          type: DELETE_SUCCESS
        });

        callback();

        return;
      }

      dispatch({
        type: DELETE_FAILURE,
        payload: response.data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      toast.error(response.message);

      dispatch({
        type: UPDATE_FAILURE,
        payload: response
      });

      if (response.errors) {
        let throwErrors = {};

        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/user-account/actions.js